<template>
  <div>
    <form>
      <h1 class="mt-4 section-divider">
        {{ $t('school.academic.operation.profile_mgt.studentProfile.father') }}
      </h1>
      <div class="row">
        <div class="col-md-4">
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label text-right">
              {{
                $t(
                  'school.academic.operation.profile_mgt.studentProfile.nameKh'
                )
              }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label">{{
                data.parent
                  ? data.parent.father_name_kh
                    ? data.parent.father_name_kh
                    : '-'
                  : '-'
              }}</label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label text-right">
              {{
                $t(
                  'school.academic.operation.profile_mgt.studentProfile.nameEn'
                )
              }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label">{{
                data.parent
                  ? data.parent.father_name_en
                    ? data.parent.father_name_en
                    : '-'
                  : '-'
              }}</label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label text-right">
              {{
                $t(
                  'school.academic.operation.profile_mgt.studentProfile.dateOfBirth'
                )
              }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label">{{
                data.parent
                  ? data.parent.father_dob
                    ? data.parent.father_dob
                    : '-'
                  : '-'
              }}</label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label text-right">
              {{
                $t(
                  'school.academic.operation.profile_mgt.studentProfile.occupation'
                )
              }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label">{{
                data.parent
                  ? data.parent.father_occupation
                    ? data.parent.father_occupation.occupation_name_en
                      ? data.parent.father_occupation.occupation_name_en
                      : '-'
                    : '-'
                  : '-'
              }}</label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label text-right">
              {{
                $t(
                  'school.academic.operation.profile_mgt.studentProfile.nationality'
                )
              }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label">{{
                data.parent
                  ? data.parent.father_nationality
                    ? data.parent.father_nationality.nationality
                      ? data.parent.father_nationality.nationality
                      : '-'
                    : '-'
                  : '-'
              }}</label>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label text-right">
              {{
                $t('school.academic.operation.profile_mgt.studentProfile.email')
              }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label">{{
                data.parent
                  ? data.parent.father_emails
                    ? data.parent.father_emails
                    : '-'
                  : '-'
              }}</label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label text-right">
              {{
                $t(
                  'school.academic.operation.profile_mgt.studentProfile.facebook'
                )
              }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label">{{
                data.parent
                  ? data.parent.father_facebook
                    ? data.parent.father_facebook
                    : '-'
                  : '-'
              }}</label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label text-right">
              {{
                $t('school.academic.operation.profile_mgt.studentProfile.line')
              }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label">{{
                data.parent
                  ? data.parent.father_line
                    ? data.parent.father_line
                    : '-'
                  : '-'
              }}</label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label text-right">
              {{
                $t(
                  'school.academic.operation.profile_mgt.studentProfile.linkIn'
                )
              }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label">{{
                data.parent
                  ? data.parent.father_linked_in
                    ? data.parent.father_linked_in
                    : '-'
                  : '-'
              }}</label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label text-right">
              {{
                $t('school.academic.operation.profile_mgt.studentProfile.phone')
              }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label"
                >{{
                  data.parent
                    ? data.parent.father_phone1
                      ? data.parent.father_phone1
                      : '-'
                    : '-'
                }}
                /
                {{
                  data.parent
                    ? data.parent.father_phone2
                      ? data.parent.father_phone2
                      : ''
                    : ''
                }}</label
              >
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="row form-group">
            <div class="col-md-12 text-center">
              <div id="img-frame" class="text-center">
                <img
                  v-lazy="{
                    src: photoFather(data),
                    error: onErrorFather(data),
                    loading: require('@/assets/Rolling-1s-200px_2.svg')
                  }"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Mother -->
      <h1 class="mt-4 section-divider">
        {{ $t('school.academic.operation.profile_mgt.studentProfile.mother') }}
      </h1>
      <div class="row">
        <div class="col-md-4">
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label text-right">
              {{
                $t(
                  'school.academic.operation.profile_mgt.studentProfile.nameKh'
                )
              }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label">{{
                data.parent
                  ? data.parent.mother_name_kh
                    ? data.parent.mother_name_kh
                    : '-'
                  : '-'
              }}</label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label text-right">
              {{
                $t(
                  'school.academic.operation.profile_mgt.studentProfile.nameEn'
                )
              }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label">{{
                data.parent
                  ? data.parent.mother_name_en
                    ? data.parent.mother_name_en
                    : '-'
                  : '-'
              }}</label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label text-right">
              {{
                $t(
                  'school.academic.operation.profile_mgt.studentProfile.dateOfBirth'
                )
              }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label">{{
                data.parent
                  ? data.parent.mother_dob
                    ? data.parent.mother_dob
                    : '-'
                  : '-'
              }}</label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label text-right">
              {{
                $t(
                  'school.academic.operation.profile_mgt.studentProfile.occupation'
                )
              }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label">{{
                data.parent
                  ? data.parent.mother_occupation
                    ? data.parent.mother_occupation.occupation_name_en
                      ? data.parent.mother_occupation.occupation_name_en
                      : '-'
                    : '-'
                  : '-'
              }}</label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label text-right">
              {{
                $t(
                  'school.academic.operation.profile_mgt.studentProfile.nationality'
                )
              }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label">{{
                data.parent
                  ? data.parent.mother_nationality
                    ? data.parent.mother_nationality.nationality
                      ? data.parent.mother_nationality.nationality
                      : '-'
                    : '-'
                  : '-'
              }}</label>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label text-right">
              {{
                $t('school.academic.operation.profile_mgt.studentProfile.email')
              }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label">{{
                data.parent
                  ? data.parent.mother_emails
                    ? data.parent.mother_emails
                    : '-'
                  : '-'
              }}</label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label text-right">
              {{
                $t(
                  'school.academic.operation.profile_mgt.studentProfile.facebook'
                )
              }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label">{{
                data.parent
                  ? data.parent.mother_facebook
                    ? data.parent.mother_facebook
                    : '-'
                  : '-'
              }}</label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label text-right">
              {{
                $t('school.academic.operation.profile_mgt.studentProfile.line')
              }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label">{{
                data.parent
                  ? data.parent.mother_line
                    ? data.parent.mother_line
                    : '-'
                  : '-'
              }}</label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label text-right">
              {{
                $t(
                  'school.academic.operation.profile_mgt.studentProfile.linkIn'
                )
              }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label">{{
                data.parent
                  ? data.parent.mother_linked_in
                    ? data.parent.mother_linked_in
                    : '-'
                  : '-'
              }}</label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label text-right">
              {{
                $t('school.academic.operation.profile_mgt.studentProfile.phone')
              }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label"
                >{{
                  data.parent
                    ? data.parent.mother_phone1
                      ? data.parent.mother_phone1
                      : '-'
                    : '-'
                }}
                /
                {{
                  data.parent
                    ? data.parent.mother_phone2
                      ? data.parent.mother_phone2
                      : ''
                    : ''
                }}</label
              >
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="row form-group">
            <div class="col-md-12 text-center">
              <div id="img-frame" class="text-center">
                <img
                  v-lazy="{
                    src: photoMother(data),
                    error: onErrorMother(data),
                    loading: require('@/assets/Rolling-1s-200px_2.svg')
                  }"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'

export default {
  name: 'parent-show',
  props: ['value'],
  data() {
    return {
      data: {},
      errors: new Errors(),
      manPhoto: require('../../../../assets/staff-default-man.png'),
      womenPhoto: require('../../../../assets/staff-default-women.png'),
      file: require('../../../../assets/user_default.png')
    }
  },
  created() {
    this.data = this.value
  },
  methods: {
    photoFather(record) {
      if (record.parent) {
        return record.parent.father_photo
      }
      return this.manPhoto
    },
    onErrorFather() {
      event ? (event.target.src = this.manPhoto) : ''
    },
    photoMother(record) {
      if (record.parent) {
        return record.parent.mother_photo
      }
      return this.womenPhoto
    },
    onErrorMother() {
      event ? (event.target.src = this.womenPhoto) : ''
    }
  }
}
</script>
<style lang="css" scoped>
#cover-image img {
  object-fit: contain;
  width: 100%;
  height: 100%;
}
.section-divider {
  border-bottom: 1px solid #eee;
  margin-bottom: 10px;
}
.text-uppercase {
  text-transform: uppercase !important;
}
#img-frame {
  display: block;
  position: relative;
  margin-top: 5px;
}
#img-frame img {
  object-fit: contain;
  width: 35%;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 3px;
  margin: 0 auto;
}
table td {
  vertical-align: middle;
}
::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: #ffff; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e5e7e7;
}
div::-webkit-scrollbar-thumb:hover {
  background: #b7b7b8;
}
</style>
